import { Button, Image, Header, Form, FormField, Message } from "semantic-ui-react"
import CarAdviseInstacartLogo from "../../../images/caradvise-instacart-logo.svg"
import CarAdviseLogo from "../../../images/CarAdvise-Logo.svg"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { EMAIL_REGEX, NUMERIC_REGEX } from "../../../shared_component/utils/stringHelpers"
import { signUp } from "../../../v1/actions/user"
import store from "../../../shared_component/utils/configureStore"
import { generatePassword } from "../../utils/generatePassword.js"
import Notifications from "../../../v1/components/Notifications"
import { routerPaths } from "../../../v1/constants/paths"
import { getSubdomain } from "../../../v1/components/Config/StylesheetInjector"
import ReCAPTCHA from "react-google-recaptcha"

const recaptchaRef = React.createRef()

const SignUp = ({ t, user, history, isReCaptchaflagEnabled }) => {
  const [email, setEmail] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [emailError, setEmailError] = useState("")
  const [phoneNumberError, setPhoneNumberError] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [affiliation, setAffiliation] = useState("")
  const [isRecaptchaChecked, setIsRecaptchaChecked] = useState(false)

  useEffect(() => {
    const affiliation = getSubdomain()
    setAffiliation(affiliation)
  }, [])

  const handleEmailChange = (e) => {
    const email = e.target.value
    setEmail(email)
    if (EMAIL_REGEX.test(email)) {
      setEmailError("")
    } else {
      setEmailError(t("emailFormatError"))
    }
  }

  const changedRecaptcha = (val) => {
    if (val.length > 0) {
      setIsRecaptchaChecked(true)
    } else {
      setIsRecaptchaChecked(false)
    }
  }

  const handlePhoneNumberChange = (e) => {
    const phoneNumber = e.target.value
    const isOnlyNumeric = NUMERIC_REGEX.test(phoneNumber)
    setPhoneNumber(phoneNumber)
    if (phoneNumber.length == 10 && isOnlyNumeric) {
      setPhoneNumberError("")
    } else {
      setPhoneNumberError(t("phoneFormatError"))
    }
  }

  const handleSubmit = async () => {
    setIsSubmitting(true)
    const password = generatePassword()

    let data = {
      email: email.toLowerCase(),
      cell_phone: phoneNumber,
      affiliation: affiliation,
      password: password
    }
    const response = await store.dispatch(signUp(data))
    if (response().result) {
      setIsSubmitting(false)
      history.push({
        pathname: routerPaths.dashboard
      })
    } else {
      const errorMessages = response().error
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: errorMessages,
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      setEmailError(errorMessages)
      setIsSubmitting(false)
    }
  }

  const isValid = () => {
    return (
      email.length &&
      phoneNumber.length &&
      !(emailError.length || phoneNumberError.length) &&
      isRecaptchaChecked === true
    )
  }

  return (
    <div className="sign_up_card">
      {affiliation == "instacart" ? (
        <Image
          className="caradvise-instacart-logo"
          src={CarAdviseInstacartLogo}
          alt="CarAdvise Instacart Logo"
        />
      ) : (
        <Image className="caradvise-logo" src={CarAdviseLogo} alt="CarAdvise Instacart Logo" />
      )}
      <Header as="h3">{t("joinCarAdvise")}</Header>
      <p className="sub_header">{t("carCareSimplified")}</p>
      <Form className="sign_up_form">
        <FormField error={emailError.length > 0}>
          <label>
            {t("your")} <span>{affiliation}</span> {t("accountEmail")}
          </label>
          <input
            placeholder={t("emailPlaceholderLabel")}
            value={email}
            onChange={handleEmailChange}
          />
          {emailError && (
            <Message size="mini" negative>
              {emailError}
            </Message>
          )}
          <label>
            {t("emailAssociated")} <span>{affiliation}</span> {t("account")}
          </label>
        </FormField>
        <FormField error={phoneNumberError.length > 0}>
          <label>{t("mobilePhoneNumber")}</label>
          <input
            maxLength={10}
            placeholder={t("phonePlaceholderLabel")}
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
          />
          {phoneNumberError && (
            <Message size="mini" negative>
              {phoneNumberError}
            </Message>
          )}
        </FormField>
        <FormField>
          {isReCaptchaflagEnabled && (
            <ReCAPTCHA
              ref={recaptchaRef}
              className="g-recaptcha"
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
              onChange={(e) => changedRecaptcha(e)}
              props={this}
            />
          )}
        </FormField>
      </Form>
      <Button
        loading={isSubmitting}
        disabled={!isValid() || isSubmitting}
        onClick={handleSubmit}
        className="primary-btn"
      >
        Sign Up
      </Button>
      <p className="carAdvise_term">
        {t("agreeToCarAdvise")}
        <a className="primary-link-orange" href="http://caradvise.com/privacy/" target="_blank">
          {t("privacyPolicyLbl")}
        </a>
        {` ${t("andLbl")} `}
        <a className="primary-link-orange" href="http://caradvise.com/terms/" target="_blank">
          {t("termsOfUseLbl")}
        </a>
        .
      </p>
      <div className="already_have_account">
        <span>{t("alreadyHaveAccount")} </span>
        <b>
          <Link to={{ pathname: routerPaths.signIn }}>{t("loginHere")}</Link>
        </b>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  let user = state.user || {}
  return {
    user
  }
}

export default connect(mapStateToProps)(withTranslation("accountDetails")(SignUp))
